export default __webpack_public_path__ + "static/media/dashboard1.a13f4dc4.svg";